import React from 'react';
import styled from 'styled-components';
import AndroidSpinner from 'inline-icons/android-loading.svg';
import IOSSpinner from 'inline-icons/iOS-loading.svg';

import { isiOS } from 'config';

const FULL_VH = document.documentElement.clientHeight;

const LoadingContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  height: ${({ headerHeight }) => FULL_VH - headerHeight}px;
  position: absolute;
  width: 100vw;
  padding-bottom: ${({ headerHeight }) => headerHeight}px;
  box-sizing: border-box;
  svg {
    ${({ theme }) => theme.LoadingIcon}
  }
`;

const LoadingPage = ({ headerHeight }: { headerHeight?: number }) => (
  <LoadingContainer
    headerHeight={headerHeight || 0}
    dangerouslySetInnerHTML={{
      __html: isiOS ? IOSSpinner : AndroidSpinner
    }}
  />
);

export default LoadingPage;
